import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sound"]

  connect() {
    this.sound = new Audio(this.data.get("path"))
    this.sound.preload = "auto"
    this.debouncedPlaySound = this.debounce(this.playSound.bind(this), 300)
  }

  playSound(event) {
    if (event.target.tagName === 'A') {
      this.sound.currentTime = 0
      this.sound.play().catch(error => {
        console.error("Failed to play sound:", error)
      })
    }
  }

  debounce(func, wait) {
    let timeout
    return function(...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }
}
